import { create } from "zustand";

const useTeacherNavStore = create((set) => ({
  tab: 1,
  selectedAplPeriodId: null,
  selectedAplTab: 1,
  setTab: (tab) => set({ tab }),
  setSelectedAplPeriodId: (id) => set({ selectedAplPeriodId: id }),
  setSelectedAplTab: (tab) => set({ selectedAplTab: tab }),
  reset: () => set({ tab: 1, selectedAplPeriodId: null, selectedAplTab: 1 }),
}));

export default useTeacherNavStore;
